import React from "react";
import { PolicyContext } from '../constants'

export const withPolicy = Component => {
  return props => <PolicyContext.Consumer>{policy => <Component {...props} policy={policy} />}</PolicyContext.Consumer>;
};